export default __webpack_public_path__ + "static/media/avatar-4.d64c26ae.png";